import React from 'react';
import clsx from 'clsx';

const TabHeader = ({ tabs, wrapperClassName, selectedTab, onTabClick }) => {
    return (
        <div className={`sticky top-0 z-100 pt-6 bg-homepage-why-bonds-bg grid grid-cols-10 items-center gap-10 w-full mx-auto ${wrapperClassName}`}>
            {tabs.map((tab, idx) => (
                <button
                    key={tab.id}
                    className={clsx(
                        'flex flex-col items-center px-2 pb-4 relative w-full',
                        selectedTab === tab.id
                            ? 'text-basicWhite h3-semibold col-span-4'
                            : 'text-primary-100 h4-medium col-span-3'
                    )}
                    onClick={() => onTabClick(idx, tab.id)}
                >
                    <div className={`flex items-center gap-2 ${selectedTab === tab.id ? 'self-start' : ""}`}>
                        {selectedTab === tab.id ? (
                            <img
                                src={tab.activeImage}
                                alt={tab.label}
                                className="w-8 h-8"
                            />
                        ) : (
                            <img
                                src={tab.image}
                                alt={tab.label}
                                className="w-6 h-6"
                            />
                        )}
                        <span className='whitespace-pre'>{tab.label}</span>
                    </div>
                    {selectedTab === tab.id && (
                        <span className="absolute left-0 right-0 -bottom-[1px] h-[1px] bg-gradient-to-r from-[#A3E1DE] via-[#FFB3B4] to-[#FFF2C4] rounded-full" />
                    )}
                </button>
            ))}
        </div>
    );
};

export default TabHeader; 